import React from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import { formatAmount, formatNegativeAmount } from 'src/utils/formatAmout';
import selectFormatDate from 'src/utils/selectDateFormat';
import dateFormatType from 'src/utils/dateFormatType';

const AccountingInterestBalanceRow = ({
  period,
  rawDate,
  initialBalance,
  subscription,
  interest,
  interestChange,
  finalBalance
}) => {
  return (
    <TableRow hover>
      <TableCell align="center">{period}</TableCell>
      <TableCell align="center">
        {selectFormatDate(rawDate, dateFormatType.MONTH_AND_YEAR)}
      </TableCell>
      <TableCell align="center">{formatAmount(initialBalance)}</TableCell>
      <TableCell align="center">{formatAmount(subscription)}</TableCell>
      <TableCell align="center">{formatNegativeAmount(interest)}</TableCell>
      <TableCell align="center">{formatAmount(interestChange)}</TableCell>
      <TableCell align="center" sx={{ fontWeight: 'bold' }}>
        {formatAmount(finalBalance)}
      </TableCell>
    </TableRow>
  );
};

AccountingInterestBalanceRow.propTypes = {
  period: PropTypes.number.isRequired,
  rawDate: PropTypes.string.isRequired,
  initialBalance: PropTypes.number.isRequired,
  subscription: PropTypes.number.isRequired,
  interest: PropTypes.number.isRequired,
  interestChange: PropTypes.number.isRequired,
  finalBalance: PropTypes.number.isRequired
};

export default AccountingInterestBalanceRow;
